import React from "react";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../../service/context";

function Sidebar(props) {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div className="w-full no-scrollbar md:w-[20%] bg-white md:overflow-x-scroll md:border-b md:space-y-3">
      <p className="block font-light text-xs text-slate-400 mt-3">
        SETTINGS
      </p>

      <ul className="w-full overflow-x-scroll space-x-2 sm:space-x-0 md:overflow-x-hidden flex mt-5 mr-3 md:block md:mt-0">
        <SidebarItem
          text="Account"
          path="/myaccount"
          active={pathname.includes("myaccount")}
        >
          <span
            className={`far fa-wrench fill-current ${
              pathname.includes("myaccount")
                ? "text-[--bg-color-500]"
                : "text-slate-400"
            } mr-2`}
          ></span>
        </SidebarItem>

        <SidebarItem
          text="Internal & External Users"
          path="/users"
          active={pathname.includes("users")}
        >
          <span
            className={`far fa-user-cog fill-current ${
              pathname.includes("users") ? "text-[--bg-color-500]" : "text-slate-400"
            } mr-2`}
          ></span>
        </SidebarItem>
        <SidebarItem
          text="Teams"
          path="/departments"
          active={pathname.includes("departments")}
        >
          <span
            className={`far fa-user-friends fill-current ${
              pathname.includes("departments")
                ? "text-[--bg-color-500]"
                : "text-slate-400"
            } mr-2`}
          ></span>
        </SidebarItem>

        <SidebarItem
          text="Assets"
          path="/assets"
          active={pathname.includes("assets")}
        >
          <svg
            viewBox="0 0 20 20"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`w-4 h-4 shrink-0 stroke-current stroke-2 ${
              pathname.includes("assets") ? "text-[--bg-color-500]" : "text-slate-400"
            } mr-2`}
          >
            <path d="M13 5C14.1046 5 15 5.89543 15 7M19 7C19 10.3137 16.3137 13 13 13C12.3938 13 11.8087 12.9101 11.2571 12.7429L9 15H7V17H5V19H2C1.44772 19 1 18.5523 1 18V15.4142C1 15.149 1.10536 14.8946 1.29289 14.7071L7.25707 8.74293C7.08989 8.19135 7 7.60617 7 7C7 3.68629 9.68629 1 13 1C16.3137 1 19 3.68629 19 7Z" />
          </svg>
        </SidebarItem>
        <SidebarItem
          text="Notifications"
          path="/notifications"
          active={pathname.includes("notifications")}
        >
          <span
            className={`far fa-bell fill-current ${
              pathname.includes("notifications")
                ? "text-[--bg-color-500]"
                : "text-slate-400"
            } mr-2`}
          ></span>
        </SidebarItem>
        {/* <SidebarItem
          text="Billing & Plan Details"
          path="/billingdetails"
          active={pathname.includes("billingdetails")}
        >
          <span
            className={`far fa-dollar-sign fill-current ${
              pathname.includes("billingdetails")
                ? "text-[--bg-color-500]"
                : "text-slate-400"
            } mr-2`}
          ></span>
        </SidebarItem> */}
        <SidebarItem
          text="Access Token"
          path="/accessToken"
          active={pathname.includes("accessToken")}
        >
          <svg
            viewBox="0 0 20 20"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`w-4 h-4 shrink-0 stroke-current stroke-2 ${
              pathname.includes("accessToken")
                ? "text-[--bg-color-500]"
                : "text-slate-400"
            } mr-2`}
          >
            <path d="M13 5C14.1046 5 15 5.89543 15 7M19 7C19 10.3137 16.3137 13 13 13C12.3938 13 11.8087 12.9101 11.2571 12.7429L9 15H7V17H5V19H2C1.44772 19 1 18.5523 1 18V15.4142C1 15.149 1.10536 14.8946 1.29289 14.7071L7.25707 8.74293C7.08989 8.19135 7 7.60617 7 7C7 3.68629 9.68629 1 13 1C16.3137 1 19 3.68629 19 7Z" />
          </svg>
        </SidebarItem>
        <SidebarItem
          text="Design Scheme"
          path="/customization"
          active={pathname.includes("customization")}
        >
          <span
            className={`fa-light fa-palette fill-current ${
              pathname.includes("customization")
                ? "text-[--bg-color-500]"
                : "text-slate-400"
            } mr-2`}
          ></span>
        </SidebarItem>
        <SidebarItem
          text="Working Hours"
          path="/working-hours"
          active={pathname.includes("working-hours")}
        >
          <span
            className={`fa-regular fa-clock fill-current ${
              pathname.includes("working-hours")
                ? "text-[--bg-color-500]"
                : "text-slate-400"
            } mr-2`}
          ></span>
        </SidebarItem>
      </ul>
    </div>
  );
}

const SidebarItem = ({ children, text, path, active }) => {
  return (
    <li className="grow mr-0.5 md:mr-0 md:mb-0.5">
      <Link
        to={path}
        className={
          "w-full flex justify-center items-center px-2.5 py-2 rounded whitespace-nowrap hover:bg-[--bg-color-50] border border-slate-200 hover:border-slate-300 text-slate-600 md:justify-start md:border-none " +
          (active ? "bg-[--bg-color-50] font-bold" : "")
        }
      >
        <div className="w-8 flex justify-center items-center">{children}</div>
        <span className="text-xs">{text}</span>
      </Link>
    </li>
  );
};

export default Sidebar;
